import * as z from 'zod';

import { itemIdValidator, nonEmptyArray, nullableCoercedNumberInput, nullableNumberInput } from './helpers';

export const ggaFreeSpinsSettingsSchema = z
  .object({
    providerId: itemIdValidator('Provider').min(1, { message: 'Provider is required.' }),
    gameId: itemIdValidator('Game').min(1, { message: 'Game is required.' }),
    playerIds: nonEmptyArray('Select at least one player.'),
    freespinAmount: nullableNumberInput(),
    betAmount: nullableCoercedNumberInput(),
    message: z
      .string({ error: 'Message is required.' })
      .trim()
      .min(1, { message: 'Message is required.' })
      .max(500, { message: 'Must be 500 characters or fewer.' }),
  })
  .superRefine((data, context) => {
    if (
      data.freespinAmount == null ||
      !Number.isInteger(data.freespinAmount) ||
      data.freespinAmount < 1 ||
      data.freespinAmount > 10_000
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['freespinAmount'],
        message: 'Must be a whole number between 1 and 10,000.',
      });
    }

    if (data.betAmount == null || data.betAmount <= 0) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['betAmount'],
        message: 'Bet amount must be greater than 0.',
      });
    } else if (Number(data.betAmount.toFixed(2)) !== data.betAmount) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['betAmount'],
        message: 'Bet amount must have no more than 2 decimal places.',
      });
    }
  });

export type GgaFreeSpinsSettingsFormData = z.infer<typeof ggaFreeSpinsSettingsSchema>;
